import React, { createContext, useContext } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

const ApiKeyContext = createContext();

export const GoogleMapAPIProvider = ({ googleMapsApiKey, children }) => {
    if (!googleMapsApiKey) {
        return children;
    }
    return (
        <ApiKeyContext.Provider value={googleMapsApiKey}>
            <APIProvider apiKey={googleMapsApiKey}>
                {children}
            </APIProvider>
        </ApiKeyContext.Provider>
    );
};

export const useApiKey = () => {
    return useContext(ApiKeyContext);
};